module.exports = __webpack_public_path__ + "static/media/yearBg.e644ec4a.jpg";